import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { tagsLimit, toasterConfig } from "../../utils/constants";
// export const tagSearchAction = (data, callback) => {
//     return (dispatch) => {
//         ApiClient.post(`${apiUrl}${PORT}/searchTags/getTags`, { searchQuery: data }).then((response) => {
//             if (response) {
//                 // dispatch({ type: "SET_SEARCHED_TAG", data: response.result });
//                 return { data: response.result }
//             }

//         });

//     }
// };
export const tagSearchAction = async (data, callback) => {
    try {
        let response = await ApiClient.post(`${apiUrl}${PORT}/searchTags/getTagsByPacket`, { packet_type: data.packet_type, searchQuery: data.modifiedSearch, page: data.page, limit: tagsLimit });
        return response.result
    } catch (error) {
        console.log(error)
    }




};